import { LoginPage } from '@/features/auth/LoginPage'
import { ToastProvider } from '@/shared/components/ToastProvider'
import { useAuth } from '@/shared/hooks/useAuth'
import { AppRouter } from './AppRouter'
import { LoadingSpinner } from '@/shared/components/ui'
import { ErrorBoundary } from '@/shared/components/ErrorBoundary'

function App() {
  const { isAuthenticated, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0A0A0A] to-[#1A1A1A]">
        <LoadingSpinner variant="text" message="Loading..." />
      </div>
    )
  }

  if (!isAuthenticated) {
    return (
      <ErrorBoundary label="App error">
        <LoginPage />
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary label="App error">
      <ToastProvider>
        <AppRouter />
      </ToastProvider>
    </ErrorBoundary>
  )
}

export default App
